<template>
    <div>
        <b-card no-body class="dashboard-container">
            <b-card-body class="px-2 pb-0 pt-2">
                <b-row class="mb-50">
                    <b-col xl="3" md="6" cols="12" class="mb-1">
                        <v-stats-box :value="stats.totalContents" text="Toplam İçerik" icon="description" variant="primary" />
                    </b-col>
                    <b-col xl="3" md="6" cols="12" class="mb-1">
                        <v-stats-box :value="stats.totalCategories" text="Kategori" icon="folder" variant="success" />
                    </b-col>
                    <b-col xl="3" md="6" cols="12" class="mb-1">
                        <v-stats-box :value="stats.totalLanguages" text="Aktif Dil" icon="language" variant="warning" />
                    </b-col>
                    <b-col xl="3" md="6" cols="12" class="mb-1">
                        <v-stats-box :value="stats.totalNavigations" text="Menü Öğesi" icon="menu" variant="info" />
                    </b-col>
                </b-row>

                <b-row class="mb-0">
                    <b-col cols="12">
                        <b-card no-body class="inner-card">
                            <b-card-body class="p-50">
                                <div class="quick-actions-grid">
                                    <div class="action-item" @click="openQuickContentModal">
                                        <div class="action-icon bg-light-primary">
                                            <feather-icon icon="FileTextIcon" size="25" class="text-primary" />
                                        </div>
                                        <span class="action-text">Yeni İçerik</span>
                                    </div>
                                    <div class="action-item" @click="openQuickCategoryModal">
                                        <div class="action-icon bg-light-success">
                                            <feather-icon icon="FolderPlusIcon" size="25" class="text-success" />
                                        </div>
                                        <span class="action-text">Yeni Kategori</span>
                                    </div>
                                    <div class="action-item" @click="openQuickNavigationModal">
                                        <div class="action-icon bg-light-warning">
                                            <feather-icon icon="MenuIcon" size="25" class="text-warning" />
                                        </div>
                                        <span class="action-text">Yeni Menü</span>
                                    </div>
                                    <div class="action-item" @click="previewWebsite">
                                        <div class="action-icon bg-light-info">
                                            <feather-icon icon="EyeIcon" size="25" class="text-info" />
                                        </div>
                                        <span class="action-text">Site Önizleme</span>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row class="match-height">
                    <b-col xl="8" cols="12">
                        <b-card no-body class="inner-card mb-2">
                            <b-card-header class="card-header-custom">
                                <div>
                                    <h5 class="mb-0">Son İçerikler</h5>
                                </div>
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    <v-select-list
                                        v-model="contentFilters.categoryId"
                                        :options="categories"
                                        :reduce="(cat) => cat.Id"
                                        label="CategoryName"
                                        placeholder="Kategori"
                                        class="select-compact"
                                        clearable
                                        @input="loadRecentContents"
                                    />
                                    <v-select-list
                                        v-model="contentFilters.languageCode"
                                        :options="languages"
                                        :reduce="(lang) => lang.LanguageCode"
                                        label="LanguageName"
                                        placeholder="Dil"
                                        class="select-compact"
                                        @input="loadRecentContents"
                                        _BCol
                                    />
                                </div>
                            </b-card-header>
                            <b-overlay :show="contentsLoading" rounded="sm">
                                <b-table :items="recentContents" :fields="contentFields" responsive show-empty empty-text="İçerik bulunamadı" class="table-compact mb-0">
                                    <template #cell(title)="data">
                                        <div class="d-flex align-items-center">
                                            <b-avatar v-if="getContentImage(data.item)" :src="getContentImage(data.item)" size="32" class="mr-1" />
                                            <div class="text-truncate" style="max-width: 300px">
                                                <div class="mb-0 font-weight-bold text-truncate">
                                                    {{ getContentTitle(data.item) }}
                                                </div>
                                                <small class="text-muted">{{ data.item.CategoryName }}</small>
                                            </div>
                                        </div>
                                    </template>
                                    <template #cell(status)="data">
                                        <div class="d-flex align-items-center justify-content-center" style="gap: 0.25rem">
                                            <b-badge :variant="data.item.IsActive ? 'light-success' : 'light-secondary'" class="badge-sm">
                                                {{ data.item.IsActive ? "Aktif" : "Pasif" }}
                                            </b-badge>
                                            <b-badge v-if="data.item.IsFeatured" variant="light-warning" class="badge-sm">
                                                <feather-icon icon="StarIcon" size="12" />
                                            </b-badge>
                                        </div>
                                    </template>
                                    <template #cell(stats)="data">
                                        <div class="d-flex align-items-center justify-content-center text-muted">
                                            <feather-icon icon="EyeIcon" size="14" class="mr-25" />
                                            <small>{{ data.item.ViewCount }}</small>
                                        </div>
                                    </template>
                                    <template #cell(actions)="data">
                                        <div class="text-nowrap text-center">
                                            <b-button variant="flat-primary" size="sm" class="btn-icon p-50" @click="quickEditContent(data.item)">
                                                <feather-icon icon="Edit2Icon" size="14" />
                                            </b-button>
                                            <b-button variant="flat-info" size="sm" class="btn-icon p-50" @click="previewContent(data.item)">
                                                <feather-icon icon="EyeIcon" size="14" />
                                            </b-button>
                                            <b-button variant="flat-danger" size="sm" class="btn-icon p-50" @click="quickDeleteContent(data.item)">
                                                <feather-icon icon="TrashIcon" size="14" />
                                            </b-button>
                                        </div>
                                    </template>
                                </b-table>
                            </b-overlay>
                        </b-card>

                        <b-row class="match-height">
                            <b-col md="6" cols="12" class="mb-0">
                                <b-card no-body class="inner-card">
                                    <b-card-header class="card-header-custom flex-shrink-0">
                                        <h5 class="mb-0">Galeriler</h5>
                                        <b-button variant="flat-primary" size="sm" :to="{ name: 'website-gallery' }"> Tümü </b-button>
                                    </b-card-header>
                                    <b-list-group flush class="list-compact" style="max-height: 250px; overflow-y: auto">
                                        <b-list-group-item v-for="category in categories.slice(0, 6)" :key="category.Id" class="d-flex justify-content-between align-items-center py-75">
                                            <div class="d-flex align-items-center">
                                                <feather-icon v-if="category.Icon" :icon="category.Icon" size="14" class="mr-50 text-muted" />
                                                <span class="font-weight-medium">{{ category.CategoryName }}</span>
                                            </div>
                                            <b-badge :variant="category.IsActive ? 'light-primary' : 'light-secondary'" pill class="badge-sm">
                                                {{ getContentCountByCategory(category.Id) }}
                                            </b-badge>
                                        </b-list-group-item>
                                    </b-list-group>
                                </b-card>
                            </b-col>
                            <b-col md="6" cols="12" class="mb-0">
                                <b-card no-body class="inner-card">
                                    <b-card-header class="card-header-custom flex-shrink-0">
                                        <h5 class="mb-0">Navigasyon</h5>
                                        <v-select-list
                                            v-model="selectedNavType"
                                            :options="navTypes"
                                            :reduce="(type) => type.value"
                                            label="label"
                                            class="select-compact"
                                            @input="loadNavigationPreview"
                                        />
                                    </b-card-header>
                                    <b-overlay :show="navLoading" rounded="sm" class="p-50">
                                        <navigation-tree-preview :items="navigationItems" :language="contentFilters.languageCode" />
                                    </b-overlay>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col xl="4" cols="12">
                        <b-card no-body class="inner-card mb-2">
                            <b-card-header class="card-header-custom">
                                <h5 class="mb-0">Diller</h5>
                                <b-button variant="flat-primary" size="sm" :to="{ name: 'website-language' }"> Yönet </b-button>
                            </b-card-header>
                            <b-list-group flush class="list-compact">
                                <b-list-group-item v-for="lang in languages" :key="lang.Id" class="d-flex justify-content-between align-items-center py-75">
                                    <div class="d-flex align-items-center">
                                        <span class="flag-icon mr-50" :class="getFlagIconClass(lang.FlagIcon)" />
                                        <span class="font-weight-medium">{{ lang.LanguageName }}</span>
                                    </div>
                                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                                        <b-badge v-if="lang.IsDefault" variant="light-success" class="badge-sm"> Varsayılan </b-badge>
                                        <b-form-checkbox :checked="lang.IsActive" switch @change="toggleLanguageStatus(lang)" />
                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>

                        <b-card no-body class="inner-card mb-2">
                            <b-card-header class="card-header-custom">
                                <h5 class="mb-0">Site Ayarları</h5>
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    <v-select-list
                                        v-model="selectedConfigLanguage"
                                        :options="configLanguageOptions"
                                        :reduce="(lang) => lang.LanguageCode"
                                        label="LanguageName"
                                        class="select-compact"
                                        @input="loadSiteConfigs"
                                    />
                                    <b-button variant="flat-primary" size="sm" :to="{ name: 'website-configuration' }"> Düzenle </b-button>
                                </div>
                            </b-card-header>
                            <div class="p-1">
                                <div v-for="config in siteConfigs.slice(0, 5)" :key="config.Id" class="config-item mb-1">
                                    <small class="text-muted d-block mb-25">{{ config.ConfigKey }}</small>
                                    <div class="font-weight-medium text-truncate">{{ truncate(config.ConfigValue, 35) }}</div>
                                </div>
                            </div>
                        </b-card>

                        <b-card no-body class="inner-card mb-2">
                            <b-card-header class="card-header-custom">
                                <h5 class="mb-0">Son Aktiviteler</h5>
                            </b-card-header>
                            <b-list-group flush class="list-compact" style="max-height: 280px; overflow-y: auto">
                                <b-list-group-item v-for="(activity, index) in recentActivities" :key="index" class="py-75">
                                    <div class="d-flex align-items-start">
                                        <b-avatar :variant="`light-${activity.type}`" size="28" class="mr-75">
                                            <feather-icon :icon="activity.icon" size="14" />
                                        </b-avatar>
                                        <div>
                                            <small class="d-block text-muted mb-25">{{ activity.time }}</small>
                                            <span class="font-weight-medium" style="font-size: 0.9rem">{{ activity.text }}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

        <b-modal id="modal-preview" title="İçerik Önizleme" size="lg" hide-footer scrollable>
            <content-preview v-if="previewData" :content="previewData" :language="contentFilters.languageCode" />
        </b-modal>

        <quick-content-modal v-model="quickModals.content" @saved="handleContentSaved" />
        <!-- <quick-category-modal v-model="quickModals.category" @saved="handleCategorySaved" /> -->
        <quick-navigation-modal v-model="quickModals.navigation" @saved="handleNavigationSaved" />
    </div>
</template>

<script>
import { BRow, BCol, BCard, BCardHeader, BCardBody, BButton, BTable, BBadge, BAvatar, BListGroup, BListGroupItem, BFormCheckbox, BOverlay } from "bootstrap-vue";
import VSelectList from "@/components/VSelectList.vue";
import WebsiteApi from "@/api/website";
import VStatsBox from "@/components/VStatsBox.vue";
import NavigationTreePreview from "./modals/NavigationTreePreview.vue";
import ContentPreview from "./modals/ContentPreview.vue";
import QuickContentModal from "./modals/QuickContentModal.vue";
import QuickCategoryModal from "./modals/QuickCategoryModal.vue";
import QuickNavigationModal from "./modals/QuickNavigationModal.vue";
import "flag-icon-css/css/flag-icons.min.css";

export default {
    name: "WebsiteDashboard",
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BButton,
        BTable,
        BBadge,
        BAvatar,
        BListGroup,
        BListGroupItem,
        BFormCheckbox,
        BOverlay,
        VSelectList,
        VStatsBox,
        NavigationTreePreview,
        ContentPreview,
        QuickContentModal,
        QuickCategoryModal,
        QuickNavigationModal,
    },
    data() {
        return {
            stats: { totalContents: 0, totalCategories: 0, totalLanguages: 0, totalNavigations: 0 },
            contentsLoading: false,
            navLoading: false,
            contentFilters: { languageCode: "tr", categoryId: null },
            selectedNavType: "main",
            navTypes: [
                { label: "Ana Menü", value: "main" },
                { label: "Footer", value: "footer" },
                { label: "Yan Menü", value: "sidebar" },
            ],
            recentContents: [],
            categories: [],
            languages: [],
            navigationItems: [],
            siteConfigs: [],
            previewData: null,
            quickModals: { content: false, category: false, navigation: false },
            contentFields: [
                { key: "title", label: "İçerik" },
                { key: "status", label: "Durum", tdClass: "text-center" },
                { key: "stats", label: "Görüntülenme", tdClass: "text-center" },
                { key: "actions", label: "İşlemler", tdClass: "text-center" },
            ],
            recentActivities: [],
            selectedConfigLanguage: "tr",
        };
    },
    created() {
        this.initializeDashboard();
    },
    computed: {
        configLanguageOptions() {
            return [{ LanguageName: "Global", LanguageCode: null }, ...this.languages];
        },
    },
    methods: {
        async initializeDashboard() {
            await Promise.all([
                this.loadStats(),
                this.loadLanguages(),
                // this.loadCategories(),
                this.loadRecentContents(),
                this.loadNavigationPreview(),
                this.loadSiteConfigs(),
                this.loadRecentActivities(),
            ]);
        },
        async loadStats() {
            try {
                const contentsRes = await WebsiteApi.Content.GetContents({ LanguageCode: "tr", IncludeTranslations: false, IncludeMetaData: false, IncludeMedia: false });
                if (contentsRes.data.Success) this.stats.totalContents = contentsRes.data.Data.length;
                // const categoriesRes = await WebsiteApi.Category.GetAll();
                // if (categoriesRes.data.Success) this.stats.totalCategories = categoriesRes.data.Data.length;
                const languagesRes = await WebsiteApi.Language.GetAll();
                if (languagesRes.data.Success) this.stats.totalLanguages = languagesRes.data.Data.filter((l) => l.IsActive == true).length;
                const navRes = await WebsiteApi.Navigation.GetTree("main", "tr");
                if (navRes.data.Success) this.stats.totalNavigations = this.countNavigationItems(navRes.data.Data);
            } catch (error) {
                console.error("Stats yüklenirken hata:", error);
            }
        },
        async loadLanguages() {
            try {
                const response = await WebsiteApi.Language.GetAll();
                if (response.data.Success) this.languages = response.data.Data;
            } catch (error) {
                console.error("Diller yüklenemedi:", error);
            }
        },
        // async loadCategories() {
        //     try {
        //         const response = await WebsiteApi.Category.GetAll();
        //         if (response.data.Success) this.categories = response.data.Data;
        //     } catch (error) {
        //         console.error("Kategoriler yüklenemedi:", error);
        //     }
        // },
        async loadRecentContents() {
            this.contentsLoading = true;
            try {
                const response = await WebsiteApi.Content.GetContents({
                    LanguageCode: this.contentFilters.languageCode,
                    CategoryId: this.contentFilters.categoryId,
                    Take: 10,
                    OrderBy: "CreateTime",
                    IncludeTranslations: true,
                    IncludeMetaData: false,
                    IncludeMedia: true,
                });
                if (response.data.Success) this.recentContents = response.data.Data;
            } catch (error) {
                console.error("İçerikler yüklenemedi:", error);
            } finally {
                this.contentsLoading = false;
            }
        },
        async loadNavigationPreview() {
            this.navLoading = true;
            try {
                const response = await WebsiteApi.Navigation.GetTree(this.selectedNavType, this.contentFilters.languageCode);
                if (response.data.Success) this.navigationItems = response.data.Data;
            } catch (error) {
                console.error("Navigasyon yüklenemedi:", error);
            } finally {
                this.navLoading = false;
            }
        },
        async loadSiteConfigs() {
            try {
                const response = await WebsiteApi.Configuration.GetAll(this.selectedConfigLanguage);
                if (response.data.Success) this.siteConfigs = response.data.Data;
            } catch (error) {
                console.error("Konfigürasyonlar yüklenemedi:", error);
            }
        },
        loadRecentActivities() {
            this.recentActivities = [
                { type: "primary", icon: "FileTextIcon", text: "Yeni içerik eklendi", time: "5 dakika önce" },
                { type: "success", icon: "Edit2Icon", text: "İçerik güncellendi", time: "15 dakika önce" },
                { type: "warning", icon: "FolderIcon", text: "Kategori oluşturuldu", time: "1 saat önce" },
                { type: "info", icon: "MenuIcon", text: "Navigasyon düzenlendi", time: "2 saat önce" },
            ];
        },
        getContentTitle(content) {
            const translation = content.Translations?.find((t) => t.LanguageCode === this.contentFilters.languageCode);
            return translation?.Title || content.ContentKey || "-";
        },
        getContentImage(content) {
            const image = content.MediaFiles?.find((m) => m.MediaType === "image" || m.MediaType === "thumbnail");
            return image?.FilePath || null;
        },
        getContentCountByCategory(categoryId) {
            return this.recentContents.filter((c) => c.CategoryId === categoryId).length;
        },
        countNavigationItems(items) {
            let count = items.length;
            items.forEach((item) => {
                if (item.ChildNavigations && item.ChildNavigations.length) count += this.countNavigationItems(item.ChildNavigations);
            });
            return count;
        },
        getFlagIconClass(langCode) {
            if (!langCode) return "flag-icon-xx";
            const code = langCode.toLowerCase();
            let iconCode;

            switch (code) {
                case "en":
                    iconCode = "gb";
                    break;
                case "tr":
                    iconCode = "tr";
                    break;
                default:
                    iconCode = code;
            }
            return `flag-icon-${iconCode}`;
        },
        async toggleLanguageStatus(language) {
            try {
                const response = await WebsiteApi.Language.ChangeStatus(language.Id);
                this.$result(response);
                if (response.data.Success) {
                    this.loadLanguages();
                    this.loadStats();
                }
            } catch (error) {
                this.$result(null, error);
            }
        },
        openQuickContentModal() {
            this.quickModals.content = true;
        },
        openQuickCategoryModal() {
            this.quickModals.category = true;
        },
        openQuickNavigationModal() {
            this.quickModals.navigation = true;
        },
        previewWebsite() {
            window.open("https://www.sertellojistik.com", "_blank");
        },
        quickEditContent(content) {
            this.$router.push({ name: "website-content", params: { editId: content.Id } });
        },
        async previewContent(content) {
            try {
                const response = await WebsiteApi.Content.GetById(content.Id, this.contentFilters.languageCode);
                if (response.data.Success) {
                    this.previewData = response.data.Data;
                    this.$bvModal.show("modal-preview");
                }
            } catch (error) {
                this.$result(null, error);
            }
        },
        async quickDeleteContent(content) {
            try {
                const confirmed = await this.$confirm("İçeriği Sil", `"${this.getContentTitle(content)}" içeriğini silmek istediğinize emin misiniz?`);
                if (confirmed) {
                    const response = await WebsiteApi.Content.Delete(content.Id);
                    this.$result(response);
                    if (response.data.Success) {
                        this.loadRecentContents();
                        this.loadStats();
                    }
                }
            } catch (error) {
                if (error !== "cancel") this.$result(null, error);
            }
        },
        handleContentSaved() {
            this.quickModals.content = false;
            this.loadRecentContents();
            this.loadStats();
        },
        // handleCategorySaved() {
        //     this.quickModals.category = false;
        //     this.loadCategories();
        //     this.loadStats();
        // },
        handleNavigationSaved() {
            this.quickModals.navigation = false;
            this.loadNavigationPreview();
            this.loadStats();
        },
        truncate(text, length) {
            if (!text) return "-";
            return text.length > length ? text.substring(0, length) + "..." : text;
        },
    },
};
</script>

<style lang="scss" scoped>
.dashboard-container {
    margin-bottom: 1.5rem;

    @at-root .dark-layout & {
        background-color: #283046;
        border-color: #3b4253;
    }

    @at-root .light-layout & {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }
}

.inner-card {
    border-radius: 0.5rem;
    border: 1px solid;
    border-color: #ebe9f1;

    @at-root .dark-layout & {
        background-color: #283046;
        border-color: #3b4253;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    }

    @at-root .light-layout & {
        background-color: #fff;
        border-color: #e9ecef;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    }
}

.card-header-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid;
    background-color: #fff;
    border-bottom-color: #e9ecef;

    @at-root .dark-layout & {
        background-color: #283046;
        border-bottom-color: #3b4253;
    }

    h5 {
        font-size: 1rem;
        font-weight: 600;

        @at-root .dark-layout & {
            color: #d0d2d6;
        }

        @at-root .light-layout & {
            color: #2c3e50;
        }
    }
}

.quick-actions-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;

    @media (max-width: 991px) {
        grid-template-columns: repeat(2, 1fr);
    }

    .action-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 0.5rem;
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        border-radius: 0.5rem;
        cursor: pointer;
        border: 1px solid transparent;
        transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background-color 0.18s ease;

        &:hover {
            transform: translateY(-3px) scale(1.03);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            border-color: #e9ecef;
            background-color: #ffffff;
        }

        @at-root .dark-layout & {
            background: #161d31;

            &:hover {
                transform: translateY(-3px) scale(1.03);
                box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
                border-color: #3b4253;
                background-color: #1e2537;
            }
        }

        .action-icon {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
        }

        .action-text {
            font-size: 0.85rem;
            font-weight: 500;

            @at-root .dark-layout & {
                color: #b4b7bd;
            }

            @at-root .light-layout & {
                color: #495057;
            }
        }
    }
}

.select-compact {
    min-width: 140px;

    ::v-deep .vs__dropdown-toggle {
        padding: 0.25rem 0.5rem;
        min-height: 32px;
        border-color: #e9ecef;

        @at-root .dark-layout & {
            background-color: #283046;
            border-color: #3b4253;
        }
    }

    ::v-deep .vs__selected {
        font-size: 0.875rem;

        @at-root .dark-layout & {
            color: #d0d2d6;
        }
    }
}

.table-compact {
    ::v-deep thead th {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        border-top: none;
        padding: 0.75rem;
        background: #f8f9fa;
        color: #6c757d;

        @at-root .dark-layout & {
            background: #161d31;
            color: #b4b7bd;
        }
    }

    ::v-deep tbody td {
        padding: 0.75rem;
        vertical-align: middle;
        border-color: #f0f0f0;

        @at-root .dark-layout & {
            border-color: #3b4253;
        }
    }

    ::v-deep tbody tr {
        &:hover {
            background: #f8f9fa;
        }
        @at-root .dark-layout & {
            &:hover {
                background: #161d31;
            }
        }
    }
}

.list-compact {
    ::v-deep .list-group-item {
        border-left: none;
        border-right: none;
        padding-left: 1rem;
        padding-right: 1rem;
        border-color: #f0f0f0;

        &:hover {
            background: #f8f9fa;
        }

        @at-root .dark-layout & {
            background-color: #283046;
            border-color: #3b4253;

            &:hover {
                background: #161d31;
            }
        }

        &:first-child {
            border-top: none;
        }

        &:last-child {
            border-bottom: none;
        }
    }
}

.badge-sm {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
}

.config-item {
    padding: 0.75rem;
    border-radius: 0.375rem;
    transition: background 0.15s;
    border: 1px solid;
    background: #f8f9fa;
    border-color: #f0f0f0;

    &:hover {
        background: #e9ecef;
    }

    @at-root .dark-layout & {
        background: #161d31;
        border-color: #3b4253;

        &:hover {
            background: #1e2537;
        }
    }

    small {
        font-size: 0.75rem;
    }
}
</style>
